/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Clear_Event_TextInputs */



/**
* | output |
* | --- |
* | "Clear Event Text" |
*
* @param {Shortcut_Keys_Name_Clear_Event_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_clear_event_text = /** @type {((inputs?: Shortcut_Keys_Name_Clear_Event_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Clear_Event_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Effacer le texte de l'evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignistext löschen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cancella testo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Очистить текст события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Borrar texto del evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("清除事件文本")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントテキストをクリア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट टेक्स्ट साफ़ करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Limpar texto do evento")
	return /** @type {LocalizedString} */ ("Clear Event Text")
});